class ErrorHelper {

    isServerError(e, status, title, parts) {
        if (!e) return false;
        if (!e.status || !e.title || !e.errorDescription) return false;
        if (status && e.status !== status) return false;
        if (title && e.title !== title) return false;

        if (parts) {
            for (let i = 0; i < parts.length; i++) {
                if (e.errorDescription.indexOf(parts[i]) < 0)
                    return false;
            }
        }

        return true;
    }

    isTokenExpired(error) {
        return this.isServerError(error, 401, 'invalid_grant', ['Token is invalid']);
    }

}

export default new ErrorHelper();


// WEBPACK FOOTER //
// src/web/ErrorHelper.js